import React from 'react';
import { Palette, Sun, Moon, Check } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { useTheme, ACCENTS } from '../../contexts/ThemeContext';

export function AppearanceSettings() {
  const { language } = useLanguage();
  const { mode, setMode, accent, setAccent } = useTheme();

  return (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-4 sm:p-6 space-y-6" data-testid="appearance-section">
      <div>
        <h2 className="text-base sm:text-lg font-bold text-gray-800 flex items-center gap-2 mb-2">
          <Palette size={18} className="text-blue-500" />
          {language === 'es' ? 'Apariencia' : 'Appearance'}
        </h2>
        <p className="text-xs sm:text-sm text-gray-500">
          {language === 'es' 
            ? 'Personaliza el color de la aplicación y el modo claro u oscuro.'
            : 'Customize the app color and light or dark mode.'}
        </p>
      </div>

      <div>
        <p className="text-sm font-bold text-gray-700 mb-3">{language === 'es' ? 'Modo' : 'Mode'}</p>
        <div className="grid grid-cols-2 gap-3">
          <button
            onClick={() => setMode('light')}
            data-testid="theme-mode-light"
            className={`flex items-center justify-center gap-2 py-3 rounded-xl border-2 font-bold text-sm transition-all ${
              mode === 'light' ? 'border-blue-500 bg-blue-50 text-blue-700' : 'border-gray-200 text-gray-500 hover:border-gray-300'
            }`}
          >
            <Sun size={18} />
            {language === 'es' ? 'Claro' : 'Light'}
          </button>
          <button
            onClick={() => setMode('dark')}
            data-testid="theme-mode-dark"
            className={`flex items-center justify-center gap-2 py-3 rounded-xl border-2 font-bold text-sm transition-all ${
              mode === 'dark' ? 'border-blue-500 bg-blue-50 text-blue-700' : 'border-gray-200 text-gray-500 hover:border-gray-300'
            }`}
          >
            <Moon size={18} />
            {language === 'es' ? 'Oscuro' : 'Dark'}
          </button>
        </div>
      </div>

      <div>
        <p className="text-sm font-bold text-gray-700 mb-3">{language === 'es' ? 'Color de acento' : 'Accent color'}</p>
        <div className="flex items-center gap-3 flex-wrap">
          {ACCENTS.map((a) => (
            <button
              key={a.id}
              onClick={() => setAccent(a.id)}
              data-testid={`accent-${a.id}`}
              title={language === 'es' ? a.es : a.en}
              className={`w-10 h-10 rounded-full flex items-center justify-center transition-all active:scale-90 ${
                accent === a.id ? 'ring-2 ring-offset-2 ring-gray-400 scale-110' : 'hover:scale-105'
              }`}
              style={{ backgroundColor: a.color }}
            >
              {accent === a.id && <Check size={18} className="text-white" />}
            </button>
          ))}
        </div>
        <p className="text-xs text-gray-400 mt-2">
          {language === 'es' 
            ? 'El color se aplica a los botones y elementos principales de la app.'
            : 'The color applies to the main buttons and elements of the app.'}
        </p>
      </div>
    </div>
  );
}
